import React from 'react';
import { Popup } from 'decentraland-ui/dist/components/Popup/Popup';
import { T } from '../../modules/translation/utils';
import ChainProvider from '../ChainProvider';
export default class ChainCheck extends React.PureComponent {
    render() {
        const { chainId, children } = this.props;
        return (React.createElement(ChainProvider, null, data => {
            const isEnabled = data.isSupported || data.chainId === chainId;
            return (React.createElement(Popup, { disabled: isEnabled, position: "top center", content: React.createElement(T, { id: "@dapps.button.network_not_supported", values: {
                        expectedChainName: React.createElement("b", null, data.appChainName)
                    } }), trigger: children(isEnabled) }));
        }));
    }
}
//# sourceMappingURL=ChainCheck.js.map